import React from 'react'
import { AutoSizer, Table, Column, SortDirection, defaultTableRowRenderer } from 'react-virtualized'

import 'react-virtualized/styles.css'

export default class SubscriberTable extends React.Component {
    getRow({ index }) {
        return this.props.subscribers[index]
    }
    onSort({ sortBy, sortDirection }) {
        this.props.onSort({
            orderBy: sortBy,
            reverseOrder: sortDirection === SortDirection.DESC
        })
    }
    renderSubscriberRow(props) {
        const row = defaultTableRowRenderer(props)
        const { children, style, className, role } = row.props
        return (
            <div style={style}>
                <div className={className}>{children}</div>
                <div style={{clear:'both'}}>test</div>
            </div>
        )
    }
    render() {
        const { subscribers, sortOrder } = this.props
        return (
            <AutoSizer>
                {({ width, height }) => (
                    <Table {...{ width, height }} headerHeight={50} rowHeight={36}
                        rowCount={subscribers.length} rowGetter={this.getRow.bind(this)}
                        sort={this.onSort.bind(this)}
                        sortBy={sortOrder && sortOrder.orderBy}
                        sortDirection={sortOrder && sortOrder.reverseOrder ? SortDirection.DESC : SortDirection.ASC}
                        rowRenderer={this.renderSubscriberRow}>
                        <Column label="Status" dataKey="status" width={100} />
                        <Column label="Unit" dataKey='unit' width={100} />
                        <Column label="Username" dataKey='username' width={100} />
                        <Column label="Name" dataKey='name' width={200} flexGrow={1} />
                        <Column label="Site" dataKey='site_name' width={100} flexGrow={1} />
                    </Table>
                )}
            </AutoSizer>
        )
    }
}



// WEBPACK FOOTER //
// ./components/SubscriberTable.jsx